export const formProfileValues = (data = {}) => ({
    type_nationality: data?.type_nationality ?? "",
    nomor: data?.nomor ?? "",
    birthdate: data?.birthdate ?? "",
    marital_status: data?.marital_status ?? "",
    religion_id: data?.religion_id ?? "",
    handphone: data?.handphone ?? "",
    email: data?.email ?? "",
  });
  